import {buildUrl} from './../utils';
import {beaconTransport, fetchTransport, pixelTransport} from './transport';

export function imagePublisher(options = {}) {
  return function imagePublisher(params, context = {}) {  // eslint-disable-line func-names
    const url = buildUrl(options, params, context);
    return pixelTransport(url, context.image);
  };
}

export function beaconPublisher(options = {}) {
  return function beaconPublisher(params, context = {}) {  // eslint-disable-line func-names
    const url = buildUrl(options, params, context);
    return beaconTransport(url).catch(() => pixelTransport(url, context.image));
  };
}

export function fetchPublisher(options = {}) {
  return function fetchPublisher(params, context = {}) {  // eslint-disable-line func-names
    const url = buildUrl(options, params, context);
    return fetchTransport(url);
  };
}



// WEBPACK FOOTER //
// ./lib/publishers.js